import React from "react";

import "../commonStyles.scss";

interface BuyButtonI {
	label: string;
	onClickHandler: () => void;
	tabIndex?: number | undefined;
}

const BuyButton = ({ label, onClickHandler, tabIndex }: BuyButtonI) => (
	<button
		aria-live="polite"
		aria-label={label}
		className="addtocart-button btn primary btn-medium background-transition"
		onClick={onClickHandler}
		role="button"
		tabIndex={tabIndex || 0}
	>
		<span dangerouslySetInnerHTML={{ __html: label }}></span>
	</button>
);

export default BuyButton;
